import { Box, Stack, Typography } from '@mui/material';
import AppPreview from '../../../assets/icons/AppPreview';
import { AppDesignSettingsWrapper, PreviewImageContainer } from './AppDesign.styles'
import { useTranslation } from 'react-i18next';

interface AppDesignPreviewProps {
  accentColor: string | null | undefined;
  companyLogoUrl: string | null | undefined;
}

function AppDesignPreview({ accentColor, companyLogoUrl }: AppDesignPreviewProps) {
  const { t } = useTranslation();
  return (
    <AppDesignSettingsWrapper sx={{ width:"250px"}}>
      <Stack spacing={2}>
        <Typography variant="h5">
          {t("configurationPage.appDesign.preview")}
        </Typography>
        <Box sx={{ position: "relative", width: "100%" }}>
          <PreviewImageContainer>
            {companyLogoUrl && <img
              key={companyLogoUrl}
              src={companyLogoUrl}
              height="100%"
              style={{ objectFit: "contain", maxWidth: "100%" }} />}
          </PreviewImageContainer>
          <Box sx={{ width: "100%" }}>
            <AppPreview color={accentColor ?? "transparent"} />
          </Box>
        </Box>
      </Stack>
    </AppDesignSettingsWrapper>
  );
}

export default AppDesignPreview